<template>
    <div :class="['page offers',{ off: !pageOn }]">
        <VHeader type="back" @back="pageOn = false;" />
        <div class="page-content">
            <div class="ad-img" v-for="ad in offers.ads">
                <img :src="ad.img" />
                <div class="btns">
                    <p class="btn-phone" @click="showLink('phone',ad)"></p>
                    <p class="btn-link" @click="showLink('link',ad)"></p>
                </div>
            </div>
        </div> 
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { pageOn } from '@/utils/pageOn.js'
import { mapActions } from 'vuex'

export default {
    name: 'offers',
    mixins: [ pageOn ],
    components: {
        VHeader
    },
    computed: {
        offers () { return this.$store.state.offers } 
    },
    mounted () {
        this.getOffers();
    },
    methods: {
        showLink ( type, ad ) {
            console.log('showLink',{ type, ad });
        },
        ...mapActions(['getTerms','getOffers'])
    }
}

</script>

<style lang="scss">
.page.offers {
    background-color: white;
    .ad-img {
        width: calc(100% - 20px);
        margin: 10px;
        float: left;
        position: relative;
        box-shadow: 0px 0px 5px 5px rgba(0,0,0,0.5);
        &:last-child { margin-bottom: 100px; }
        img { width: 100%; }
        .btns {
            position: absolute;
            width: 100%;
            bottom: 0px;
            background-color: white;
            color: red;
            background-color: rgba(200,200,200,0);
            p { width: 50%; height: 120px; background-color: rgba(200,0,0,0); float: left; margin: 0px; top: 0px; }
        }
        p { position: relative; top: -15px; }
        p:last-child { margin-bottom: -3px; }
    }
}
</style>